import React, { MouseEvent } from 'react';
import cx from 'classnames';

export default function Close(props: {
  className?: string;
  onClick?: (e: MouseEvent) => void;
  strokeColor?: string;
}) {
  return (
    <svg
      className={cx(props.className, 'icon', 'icon-close')}
      onClick={props.onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
    >
      <path
        d="M1.2002 0.700012L10.8002 10.3M1.2002 10.3L10.8002 0.700012"
        stroke={props.strokeColor || 'black'}
        strokeOpacity="1"
        strokeLinecap="round"
      />
    </svg>
  );
}
